<template>
  <div>
    <a-drawer
      title="Create a new tenant"
      width="60%"
      @close="onClose"
      :visible="isDrawerVisible"
      :wrapStyle="{height: 'calc(100% - 108px)',overflow: 'auto',paddingBottom: '108px'}"
    >
      <a-spin size="large" :spinning="loading">
      <a-form :form="form" :layout="formLayout" style="margin-top:1em;" class="create_tenant">
        <a-text-field
          varName="name"
          varLabel="Tenant Name"
          :varRequired="true"
          :size="size"
          :formLayout="formLayout"
        />
        <a-slug-field
          varName="slug"
          varLabel="Tenant Domain Slug"
          :varRequired="true"
          :formLayout="formLayout"
          :size="size"
          prefix="https://"
          :suffix="suffix"
          description="Slug containing only lower-case letters, numbers, hyphens. This will be your default tenant domain. Once tenant created, you can add one or more secured custom domains."
        />
        <a-switch-field
          varName="organisations_enabled"
          varLabel="Enable Organizations?"
          :varRequired="true"
          :formLayout="formLayout"
          :size="size"
          v-show="false"
          description="If your digital platform or product is business-to-busienss (B2B) focused, you should ideally enable organizations."
        />
        <a-submit-button
          @submit="handleSubmit"
          :formLayout="formLayout"
          btn_text="Create Tenant"
          styled="margin-top:0.5em;"
        />
      </a-form>
    </a-spin>
    </a-drawer>
  </div>
</template>

<script>
import axiomsSubDomain from "@/helpers/AxiomsSubDomain";

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      formLayout: "vertical",
      size: "large",
      loading: false
    };
  },
  methods: {
    onClose() {
      this.$store.dispatch("ui/hideDrawer", {
        drawer_name: "create_tenant"
      });
    },
    changeTenant(uuid) {
      console.log(uuid);
      this.$auth.switch_organization(uuid);
    },
    handleSubmit() {
      const form = this.form;
      form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.loading = true;
            var tenant;
            tenant = await this.$store.dispatch("core/createItem", {
              endpoint: "tenants",
              data: values
            });
            await this.$store.dispatch("axioms/getUserInfo");
            this.loading = false;
            await this.$store.dispatch("ui/hideDrawer", {
              drawer_name: "create_tenant"
            });
            await this.$notification.open({
                message: 'New tenant created!',
                description: 'Please use tenant switcher to change tenant.',
                icon: <a-icon type="check-circle" theme="filled" style="color: green" />
            });
            this.changeTenant(tenant.uuid);
          } catch (error) {
            console.error(error);
            this.loading = false;
            form.setFields({
              slug: {
                value: values.slug,
                errors: [new Error(`${error.response.data.slug[0]}`)]
              }
            });
          }
        } else {
          console.error("Error! Check submitted values: ", values);
        }
      });
    }
  },
  computed: {
    isDrawerVisible() {
      return this.$store.state.ui.create_tenant;
    },
    suffix() {
      return `${axiomsSubDomain()}`
    }
  }
};
</script>
